<template>
  <div class="complaint-shop-detail" v-loading="loading">
    <template v-if="comData.id">
      <page-title title="投诉状态">
        <ul class="info-form" style="margin-bottom: 16px">
          <li class="form-item">
            <span class="form-item-label">处理状态：</span>
            <div class="form-item-content">
              <handle-label :state="handleState"></handle-label>
            </div>
          </li>
        </ul>
      </page-title>
      <div class="flex-row">
        <page-title title="店铺信息" class="complaint-shop-panel">
          <ul class="info-form" style="min-width: 310px">
            <li class="form-item">
              <span class="form-item-label">店铺名称：</span>
              <div class="form-item-content">
                <i class="el-icon-circle el-icon-s-shop" style="background-color: #005bff"></i>
                <span>{{ storeName }}</span>
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">联系方式：</span>
              <div class="form-item-content">
                {{ storeContact }}
              </div>
            </li>
          </ul>
        </page-title>
        <page-title title="买家信息" class="complaint-shop-panel">
          <ul class="info-form" style="min-width: 310px">
            <li class="form-item">
              <span class="form-item-label">买家昵称：</span>
              <div class="form-item-content">
                <i class="el-icon-circle el-icon-user-solid" style="background-color: #00bd83"></i>
                <span>{{ comData.buyerNickName }}</span>
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">联系方式：</span>
              <div class="form-item-content">
                {{ comData.phone }}
              </div>
            </li>
          </ul>
        </page-title>
        <page-title title="投诉信息" class="complaint-shop-panel" style="flex: 1">
          <ul class="info-form">
            <li class="form-item">
              <span class="form-item-label">投诉编号：</span>
              <div class="form-item-content">
                {{ comData.complaintNo }}
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">投诉类型：</span>
              <div class="form-item-content" style="max-width: 220px">
                {{ COMPLAINT_TYPE_ZH[comData.type] }}
              </div>
              <span class="form-item-label">投诉时间：</span>
              <div class="form-item-content">
                {{ comData.applyTime }}
              </div>
            </li>
            <li class="form-item">
              <span class="form-item-label">投诉说明：</span>
              <div class="form-item-content">
                {{ comData.description }}
              </div>
            </li>
            <li class="form-item" v-if="medias.length">
              <span class="form-item-label">凭证：</span>
              <div class="form-item-content">
                <el-image v-for="media in medias" :key="media" :src="media" :preview-src-list="medias" />
              </div>
            </li>
          </ul>
        </page-title>
      </div>
      <page-title title="订单信息">
        <span slot="title" style="font-size: 12px; font-weight: 400; color: #8998a0"> （订单号：{{ order.orderNo }}） </span>
        <el-table :data="[{}]" style="width: 100%" :header-cell-style="{ backgroundColor: `#f7f7f7` }" border>
          <el-table-column label="商品信息" width="880">
            <div style="display: flex">
              <img v-pic="orderItem.goodsImage.location" alt="" />
              <div class="table-inner-info">
                <span>{{ orderItem.goodsName }}</span>
                <p style="max-width: 582px">
                  <!-- 权利编号：805, 权利限制：独占, 授权类型：无限制, 传播方式：无限制,
                传播地域：无限制, 传播语言：无限制, 开始日期：2020-12-01,
                结束日期：2021-01-29使用次数：1, 报价：36720.00 -->
                  <span v-for="item in orderItem.specifications"> {{ item.name }}: {{ item.value }},&nbsp; </span>
                </p>
              </div>
            </div>
          </el-table-column>
          <el-table-column label="单价" align="center">
            <span v-if="orderItem.originalPrice > 0">￥{{ orderItem.price.toFixed(2) }}</span>
            <span v-if="orderItem.originalPrice < 0">面议</span>
          </el-table-column>
          <el-table-column label="交易状态" align="center">
            <span>{{ ORDERSTATUS_ZH[orderItem.status] }}</span>
          </el-table-column>
          <el-table-column label="实付款" align="center">
            <span style="color: #005bff">￥{{ orderItem.amount.toFixed(2) }}</span>
          </el-table-column>
        </el-table>
      </page-title>
      <page-title title="处理信息">
        <ul class="process-list">
          <process-item
            v-if="handleState === HANDLESTATUS.CANCELLED"
            :name="comData.buyerNickName || '买家昵称'"
            :time="comData.cancelledTime"
            :des="`撤回投诉申请，撤回原因：${comData.cancelledReason || '无'}`"
            :avatar="userInfo.avatar"
            :imgs="[]"
            oauth
          >
          </process-item>
          <process-item
            v-if="handleState === HANDLESTATUS.HANDLED"
            :name="'平台'"
            :time="comData.processingTime"
            :des="`平台已处理，处理结果：${comData.result}`"
            avatar=""
            :imgs="[]"
            oauth
          />
          <process-item
            v-if="handleState === HANDLESTATUS.REJECT"
            :name="'平台'"
            :time="comData.rejectTime"
            :des="`平台已驳回，驳回原因：${comData.rejectReason}`"
            avatar=""
            :imgs="[]"
            oauth
          />
          <process-item
            v-if="comData.sellerExplain"
            :name="sellerInfo.name"
            :time="comData.sellerExplainTime"
            :des="`卖家解释：${comData.sellerExplain}`"
            :avatar="sellerInfo.logo"
            :imgs="[]"
          />
          <process-item
            :name="comData.buyerNickName || '买家昵称'"
            :time="comData.applyTime"
            :des="`发起了投诉申请，投诉类型：${COMPLAINT_TYPE_ZH[comData.type]}。`"
            :avatar="userInfo.avatar"
            :imgs="comData.mediaItems"
            oauth
          />
        </ul>
      </page-title>
      <page-title title="处理">
        <div class="form-item">
          <span class="form-item-label" style="width: auto">备注（仅工作人员可见）：</span>
          <div class="form-item-content">
            <el-input
              :disabled="comData.state === 'FINISH'"
              v-model="remarks"
              @change="handleRemark"
              placeholder="备注"
              type="textarea"
              resize="none"
              rows="5"
            ></el-input>
          </div>
        </div>
        <div class="btn-grp" v-if="comData.state !== 'FINISH'">
          <template v-if="handleState === HANDLESTATUS.HANDLING">
            <el-button
              @click="
                dialogTitle = '驳回投诉';
                dialogVisible = true;
              "
            >
              驳回投诉
            </el-button>
            <el-button
              @click="
                dialogTitle = '已处理';
                dialogVisible = true;
              "
            >
              已处理
            </el-button>
          </template>
          <template v-else>
            <el-button @click="toHandle">处理投诉</el-button>
            <el-button @click="$router.replace('/complaint?type=0')">关闭</el-button>
          </template>
        </div>
      </page-title>
    </template>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
      <div class="vertify-complete" v-if="dialogTitle === '已处理'">
        <el-form label-width="120px">
          <el-form-item label="处理结果：">
            <el-input v-model="handleResult" placeholder="请输入" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="vertify-fail" v-if="dialogTitle === '驳回投诉'">
        <el-form label-width="120px">
          <el-form-item label="驳回原因：">
            <el-input v-model="rejectReason" placeholder="请输入" type="textarea" rows="7" resize="none"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-grp" slot="footer" style="padding: 0">
        <el-button v-if="dialogTitle === '已处理'" @click="handled">确定</el-button>
        <el-button v-if="dialogTitle === '驳回投诉'" @click="reject">确定</el-button>
        <el-button @click="dialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PageTitle from '@/components/pageTitle';
import ProcessItem from './components/processItem';
import {
  getStoreComplaintById,
  handledStoreComplaintById,
  handleStoreComplaintById,
  rejectStoreComplaintById,
  toHandleStoreComplaintById
} from '@/api/req';
import HandleLabel from './components/handleLabel.vue';
import { HANDLE_STATE, ORDER_STATUS, ORDER_STATUS_ZH, COMPLAINT_TYPE_ZH } from './_eum';
import { echoAddress } from '@/config/config';

export default {
  components: { PageTitle, ProcessItem, HandleLabel },
  name: 'complaintShopDetail',
  data() {
    return {
      loading: true,
      comData: {},
      remarks: '',
      dialogTitle: '',
      dialogVisible: false,
      rejectReason: '',
      handleResult: ''
    };
  },
  computed: {
    HANDLESTATUS: () => HANDLE_STATE,
    ORDERSTATUS_ZH: () => ORDER_STATUS_ZH,
    COMPLAINT_TYPE_ZH: () => COMPLAINT_TYPE_ZH,
    shopId() {
      return this.$route.params.id;
    },
    handleState() {
      return this.comData.handleState || HANDLE_STATE.TO_HANDLE;
    },
    order() {
      return this.comData.order || {}; //防止后端该字段缺失（😅
    },
    orderItem() {
      return this.comData.orderItem || {}; // 同上
    },
    storeContact() {
      return this.comData?.order?.store?.contact?.phone || '- -'; //可选链防止字段缺失
    },
    storeName() {
      return this.comData?.order?.store?.name || '- -';
    },
    userInfo() {
      return this.comData.userInfoModelVO || '';
    },
    sellerInfo() {
      const { name, logoFiles } = this.comData.order?.store;
      const logo = logoFiles?.[0]?.location;
      return { name, logo };
    },
    medias() {
      return this.comData?.mediaItems?.map(m => echoAddress + m.location) || [];
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$ajax
        .get(getStoreComplaintById(this.shopId))
        .then(({ data }) => {
          this.loading = false;
          this.comData = data;
          this.remarks = data.remarks;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
          this.$message.info('加载失败，请刷新重试');
        });
    },
    toHandle() {
      this.$confirm('确定开始处理该条投诉？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax
          .put(toHandleStoreComplaintById(this.shopId))
          .then(res => {
            this.getData();
            this.$message.success('已开始处理');
            this.dialogVisible = false;
          })
          .catch(err => {
            this.$message.info('请求失败');
            this.dialogVisible = false;
          });
      });
    },
    handleRemark(val) {
      this.$ajax
        .put(handleStoreComplaintById(this.shopId), {
          remarks: val
        })
        .catch(err => {
          this.$message.info('保存备注失败');
        });
    },
    handled() {
      if (!this.handleResult) {
        this.$message.info('请填写处理内容！');
        return;
      }
      this.$ajax
        .put(handledStoreComplaintById(this.shopId), {
          result: this.handleResult
        })
        .then(res => {
          this.getData();
          this.$message.success('成功处理');
          this.dialogVisible = false;
        })
        .catch(err => {
          this.$message.info('处理失败');
        });
    },
    reject() {
      if (!this.rejectReason) {
        this.$message.info('请填写驳回理由！');
        return;
      }
      this.$ajax
        .put(rejectStoreComplaintById(this.shopId), {
          rejectReason: this.rejectReason
        })
        .then(res => {
          this.getData();
          this.$message.success('成功处理');
          this.dialogVisible = false;
        })
        .catch(err => {
          this.$message.info('处理失败');
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss">
.complaint-shop-detail {
  min-height: 500px;
  .flex-row {
    display: flex;
    & > .complaint-shop-panel {
      &:not(:last-of-type) {
        margin-right: 16px;
      }
    }
  }
  .info-form {
    // padding: 24px 20px;
    background-color: white;
    border-radius: 4px;
  }
  .form-item {
    margin-top: 20px;
    display: flex;
    align-items: center;
    &:first-child {
      margin-top: 0;
    }
    &-label {
      width: 60px;
      height: 20px;
      font-size: 12px;
      font-weight: 500;
      color: #8998a0;
      line-height: 20px;
      margin-right: 6px;
      align-self: flex-start;
    }
    &-content {
      flex: 1;
      font-size: 14px;
      font-weight: 400;
      color: #040b28;
      line-height: 20px;
      max-width: 960px;
      .el-image {
        height: 78px;
        width: 78px;
        border-radius: 4px;
        margin-right: 8px;
        .el-icon-circle-close {
          font-size: 40px;
        }
      }
    }
  }
  .btn-grp {
    padding: 30px 0;
    background-color: white;
    border-radius: 4px;
    .el-button {
      padding: 13px 30px;
      border-color: #002b9c;
      color: #002b9c;
      &:not(.is-disabled):hover {
        background-color: #002b9c;
        color: white;
      }
    }
    .is-disabled {
      border: 1px dashed #8998a0;
      color: #8998a0;
    }
  }
  .el-icon-circle {
    margin-right: 8px;
    color: #fff;
    vertical-align: middle;
  }
  .el-table {
    border: 1px solid #ebeef5;
    border-bottom: none;
    img {
      height: 90px;
      width: 90px;
      border-radius: 4px;
    }
    & > span {
      color: #8998a0;
    }
    .table-inner-info {
      margin-left: 16px;
      flex: 1;
      & > span {
        color: #040b28;
        line-height: 20px;
        margin-bottom: 6px;
      }
      & > p {
        line-height: 20px;
      }
    }
  }
}
</style>
